/**
 * CSVプレビューコンポーネント
 *
 * CSV出力結果のプレビュー表示とダウンロード機能
 */

import { Text, Group, Button, Badge, Box, Table } from "@mantine/core";
import { Download, FileSpreadsheet } from "lucide-react";
import { PlaygroundResult } from "../../services/playgroundService";

interface TimelineCsvPreviewProps {
  csvPreview: NonNullable<PlaygroundResult["csvPreview"]>;
  onDownload: () => void;
}

export function TimelineCsvPreview({
  csvPreview,
  onDownload,
}: TimelineCsvPreviewProps) {
  return (
    <Box
      mt="xs"
      p="sm"
      style={{
        backgroundColor: "var(--mantine-color-default)",
        borderRadius: "6px",
        border: "1px solid var(--mantine-color-default-border)",
      }}
    >
      <Group justify="space-between" align="center" mb="xs">
        <Group gap="xs">
          <FileSpreadsheet size={14} />
          <Text size="sm" fw={500}>
            {csvPreview.filename}
          </Text>
          <Badge size="xs" variant="light" color="gray">
            {csvPreview.encoding.toUpperCase()}
          </Badge>
        </Group>
        <Button
          variant="light"
          size="xs"
          leftSection={<Download size={12} />}
          onClick={onDownload}
        >
          ダウンロード
        </Button>
      </Group>
      <Box style={{ overflowX: "auto" }}>
        <Table striped highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              {csvPreview.rows[0]?.map((header, i) => (
                <Table.Th key={i} style={{ fontSize: "12px" }}>
                  {header}
                </Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {csvPreview.rows.slice(1).map((row, rowIndex) => (
              <Table.Tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <Table.Td key={cellIndex} style={{ fontSize: "12px" }}>
                    {cell}
                  </Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Box>
    </Box>
  );
}
